import { render, staticRenderFns } from "./basicInformation.vue?vue&type=template&id=7ed3c2fa&scoped=true"
import script from "./basicInformation.vue?vue&type=script&lang=js"
export * from "./basicInformation.vue?vue&type=script&lang=js"
import style0 from "./basicInformation.vue?vue&type=style&index=0&id=7ed3c2fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed3c2fa",
  null
  
)

export default component.exports